import { css } from "@emotion/css";
import { linearGradient, scrollYCss } from "@snapchat/emotion-helpers";

const MAX_EULA_TEXT_WIDTH = "75ch";

export const absolutePositionCss = css({
    maxWidth: MAX_EULA_TEXT_WIDTH,
    position: "absolute",
    width: "100%",
});

const gradientHeight = "65px";

export const fadeEffectCss = css({
    "&:after": {
        backgroundImage: linearGradient("rgba(255, 255, 255, 0) 0%", "rgba(255, 255, 255, 1) 100%"),
        bottom: 0,
        content: '""',
        height: gradientHeight,
        left: 0,
        pointerEvents: "none",
        position: "absolute",
        width: "100%",
    },
    position: "relative",
});

export const eulaBodyContainerCss = css({
    overflow: "hidden",
    overflowY: "auto",
    position: "relative",
});

export const eulaBodyCss = css(scrollYCss, {
    margin: "0 auto",
    maxWidth: MAX_EULA_TEXT_WIDTH,
});

export const eulaBodyHeightWithButtons = css({
    height: "calc(100vh - 250px)",
});

export const eulaBodyHeightWithoutButtons = css({
    height: "calc(100vh - 200px)",
});

export const eulaButtonsContainerCss = css({
    justifyContent: "center",
    display: "flex",
    ".sds-base-button.ant-btn": {
        width: "200px",
        height: "40px",
        marginTop: "8px",
    },
});
